import { render, staticRenderFns } from "./LastVSGames.vue?vue&type=template&id=5301b07f&scoped=true&"
import script from "./LastVSGames.vue?vue&type=script&lang=js&"
export * from "./LastVSGames.vue?vue&type=script&lang=js&"
import style0 from "./LastVSGames.vue?vue&type=style&index=0&id=5301b07f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301b07f",
  null
  
)

export default component.exports